
import styles from "./index.module.scss";

import { useTranslation } from "react-i18next";
import {
  IsCoachee
} from "../../config/Roles";
import { Metric, MetricsWrapper } from "../Metric";

function DashboardMetrics({ data }) {
  const { t } = useTranslation();
  const numberFormat = new Intl.NumberFormat();
  return (


    <div style={{
      display: 'flex',
      width: '156%',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {IsCoachee() && (
        <div className={styles.metrics} >
          <MetricsWrapper dashboard={true}>
            <Metric
              fullWidth
              color="#0A859A"
              label={t("dashboard.executive.totalInprogress")}
              data={numberFormat.format(data?.totalInprogressSession)}
            />
            <Metric
              fullWidth
              color="#13C77A"
              label={t("dashboard.executive.totalSessionClosed")}
              data={numberFormat.format(data?.totalCompletedSession)}
            />
          </MetricsWrapper>
        </div>
      )}

      {!IsCoachee() && (
        <>
          <div className={styles.metrics}>
            <MetricsWrapper dashboard={true}>
              <Metric
                fullWidth
                color="#0A859A"
                label={t("dashboard.executive.totalInprogress")}
                data={numberFormat.format(data?.totalInprogressSession || 0)}
              />
              <Metric
                fullWidth
                color="#13C77A"
                label={t("dashboard.executive.totalSessionClosed")}
                data={numberFormat.format(data?.totalCompletedSession || 0)}
              />
              <Metric
                fullWidth
                color="#FF9C12"
                label={t("dashboard.executive.totalCoachees")}
                data={numberFormat.format(data?.totalCoachees || 0)}
              />

            </MetricsWrapper>
          </div>
        </>
      )}



    </div>
  );
}

export default DashboardMetrics;